import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';

const FullScreenLoading = () => (
  <Backdrop sx={{ color: '#fff' }} open>
    <CircularProgress color="inherit" />
  </Backdrop>
);

export default FullScreenLoading;
